module.exports = __webpack_public_path__ + "static/media/dark-submenu-centrocusto.128ead7a.svg";